

export class SettingsPassOnLog {
    constructor(
        public id: number = null,
        public corporationNumberBdId: number = null,
        public corporationNumberName: string = '',
        public showPopupUponDashboard = {
            active: false,
            roles: []
        },
        public staffNotificationSettings: Array<any> = [],
        public residentsNotificationSettings: Array<any> = [],
        public createdBy: string = '',
        public createdAt: string = '',
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public checked: boolean = false
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/SettingsPassOnLog.ts